import LegalPage from '../components/LegalPage'
import privacy from '../../../legal/privacy-policy.md?raw'

export default function PrivacyPolicy() {
  return <LegalPage markdown={privacy} title="Privacy Policy" />
}
